import {Collection} from './../api/Collection';
import {IQueue} from './../api/IQueue';

export class QueueCollection<T> extends Collection<T> implements IQueue<T> {
    constructor(private capacity: number = Infinity) {
        super();
    }

    clone(): QueueCollection<T>{
        var new_queue=new QueueCollection<T>();
        this.storage.forEach((value)=>{
            new_queue.enqueue(value);
        });

        return new_queue;
    }

    enqueue(item: T): void {
        if (this.isFull()) {
            throw Error("Queue has reached max capacity, you cannot add more items");
        }
        // In the derived class, we can access protected properties of the abstract class
        this.storage.push(item);
    }
    dequeue(): T | undefined {
        return this.storage.shift();
    }

    top(): T | null{
        if(this.storage.length===0){
            return null;
        }else{
            return this.storage[0];
        }
    }

    // Implementation of the abstract method
    isFull(): boolean {
        return this.capacity === this.size();
    }
}